import { PaymentState } from './state';

export const productsInitialState: PaymentState = {
  methods: {},
};
